<template>
  <v-app>
    <v-app-bar
      app
      hide-on-scroll
      prominent
      :color="toolbarColor"
      :dark="toolbarDark"
      ref="bar"
    >
      <div class="d-flex align-center mr-8">
        <router-link to="/accueil">
          <v-img
            alt="Logo ministère justice"
            contain
            class="shrink mr-2"
            src="/images/logo.svg"
            height="120"
            to="/accueil"
          />
        </router-link>

        <v-img
          class="d-none d-sm-flex"
          alt="Logo EPELFI"
          contain
          src="/images/epelfi_logo_2.png"
          height="80"
          max-width="180"
        />
      </div>
      <v-toolbar-items class="align-center d-none d-sm-flex">
        <div class="application-title">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <span class="application-name-title" v-bind="attrs" v-on="on">
                Associations Alsace-Moselle
              </span>
            </template>
            <v-card>
              <v-card-title>
                <v-icon>mdi-git</v-icon>Versions de l'application
              </v-card-title>
              <v-divider />
              <v-card-text>
                Ces informations sont destinées à la communication avec le support en cas
                de besoin.
                <v-list>
                  <v-list-item v-if="versionFront">
                    <v-list-item-title> Front : {{ versionFront }} </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title> Back : {{ versions.api }} </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      Authentification : {{ versions.oauth2 }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-menu>

          <span v-if="environnement" class="white--text">
            <v-icon>{{ environnementIcon }}</v-icon>
            &nbsp;{{ environnement }}
          </span>
        </div>
      </v-toolbar-items>
      <v-spacer />

      <v-fade-transition>
        <v-toolbar-items v-if="logged">
          <div class="d-flex align-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn tile outlined v-bind="attrs" v-on="on" data-testid="bouton-menu-utilisateur">
                  <v-icon> mdi-account-outline </v-icon>
                  <span class="ma-2" style="text-transform: none !important">{{
                    utilisateur
                  }}</span>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="versCompte" data-testid="menu-mon-compte">
                  <v-list-item-icon>
                    <v-icon>mdi-account-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Mon compte</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="logout" data-testid="menu-se-déconnecter">
                  <v-list-item-icon>
                    <v-icon color="error">mdi-power</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="error--text"
                      >Se déconnecter</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar-items>
      </v-fade-transition>

      <template #extension v-if="logged">
        <v-tabs
          align-with-title
          :color="toolbarDark ? null : 'secondary'"
          :dark="toolbarDark"
          show-arrows
        >
          <v-tab to="/accueil">Accueil</v-tab>
           <v-tab to="/requete">Mon suivi</v-tab>
          <v-tab to="/mes-associations">Mes associations</v-tab>
          <v-tab to="/association" :exact="false">Consulter le Registre</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-main class="background">
      <a-vuex-snackbar />
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>

    <v-footer
      style="background-color: white; border-top: 1px solid var(--v-grey-base)"
      class="d-flex align-center"
    >
      <div style="max-width: 200px">
        <v-img
          alt="Logo ministère justice"
          class="shrink mr-2"
          src="/images/logo.svg"
          contain
        />
      </div>

      <v-spacer />

      <a-cgu-faq-link :lienCGU="lienCGU" :lienFAQ="lienFAQ" />

      <v-spacer />

      <div>
        <v-img
          alt="Logo EPELFI"
          contain
          src="/images/epelfi_logo_2.png"
          height="30"
          max-width="80"
          style="margin-left: -9px"
        />
        <div>2A Rue de l'Artisanat</div>
        <div>67700 Saverne</div>
        <div>Support : 0800 206 126 / associations.epelfi@justice.fr</div>
      </div>

    </v-footer>
  </v-app>
</template>

<script>
import { version } from "../package.json";
import { etatAssociationSelectItems } from "@/filters/etatassociation";
import { initService, oauth2Service, actuatorService } from "@/services";
import { mapGetters } from "vuex";
export default {
  watch: {
    $route() {
      //on ouvre la barre de menu
      //CF. https://github.com/vuetifyjs/vuetify/issues/12505
      this.$refs.bar.isActive = true;
    },
  },
  mounted() {
    initService.init().then(e => {
      this.$store.commit("fichiers/init", e);
      var tribunaux = e.tribunaux.map(t => t.id);
      var etats = etatAssociationSelectItems().map(a => a.value);
      this.$store.commit("tables/associations/searchParameters", {
        field: "tribunal",
        value: tribunaux,
      });
      this.$store.commit("tables/associations/searchParameters", {
        field: "etats",
        value: etats,
      });

      actuatorService.version().then(versions => {
        this.$store.commit("utilisateur/versions", versions);
      });
    });
  },
  methods: {
    logout() {
      oauth2Service.logout();
      this.$store.commit("utilisateur/logout");
      this.$router.push("/logout");
    },
    versCompte() {
      this.$router.push({ path: "/utilisateur/modification" });
    },
  },
  computed: {
    logged() {
      return !!this.utilisateur;
    },
    toolbarDark() {
      return this.envSpecial;
    },
    envSpecial() {
      return !!this.environnement;
    },
    environnementIcon() {
      var env = (this.environnement || "").toLowerCase();
      if ("formation" === env) {
        return "mdi-school";
      }
      return "mdi-bug";
    },
    toolbarText() {
      if (this.envSpecial) {
        return "white";
      }
      return "primary";
    },
    toolbarColor() {
      if (this.envSpecial) {
        return "secondary";
      }
      return "white";
    },
    ...mapGetters({
      utilisateur: "utilisateur/libelle",
      versions: "utilisateur/versions",
      environnement: "fichiers/environnement",
      lienCGU: "fichiers/lienCGU",
      lienFAQ: "fichiers/lienFAQ",
    }),
    versionFront() {
      return version;
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/global.scss";
@import "./assets/styles/typographie.scss";

h1 {
  color: var(--v-darkgrey-base);
  caret-color: var(--v-darkgrey-base);
  font-size: 2.125rem;
  font-weight: 400;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em;
  font-family: "Roboto", sans-serif;
  padding: 20px;
  margin-bottom: 8px;
  margin-top: 20px;
}

.accent-block {
  border-left: 3px solid var(--v-accent-base);
  padding-left: 10px;
  strong {
    color: var(--v-accent-base);
  }
}
@media only screen and (max-width: 959px) {
  .v-stepper__label {
    display: flex !important;
  }
}
.v-list {
  .v-list-item.theme--dark.v-list-item--disabled {
    $disabled: rgba(255, 255, 255, 0.5);
    color: $disabled;
    .v-icon {
      color: $disabled;
    }
  }
  .v-list-item--disabled {
    opacity: 0.33;
  }
}

form.login {
  max-width: 700px;
  flex-grow: 1;
}
.hint-multiligne.v-input .v-messages__message {
  line-height: inherit !important;
}

.v-input .theme--light.v-messages {
  color: currentColor;
}

.v-card {
  .v-card__title {
    word-break: normal;
  }
}

td.email {
  word-break: break-all;
}

</style>
